import { gql } from "@apollo/client";

// The import task's TDAs: importFileUuid and parentInstalledBaseNodeId are set by
// the modal itself, only moveExistingAssets is shown to the user.
export const BackgroundTaskImportTdas = gql`
    query BackgroundTaskImportTdas {
        backgroundTaskList {
            typeDefinitionAttributeList {
                typeDefinitionAttributes {
                    index
                    name
                    hint
                    inputType
                    value
                }
            }
        }
    }
`;
